module.exports = __webpack_public_path__ + "30ac64f2985d1bc5a8dfb54f70128e3b.svg";